import { createSelector } from 'reselect';

const selectDBAIncementalLogs = (state: any) => state.dbaIncementalLogs;

export const selectDBAIncementalLogsCurrentItem = createSelector([selectDBAIncementalLogs], (dbaIncementalLogs) => dbaIncementalLogs.current);

export const selectDBAIncementalLogsListItems = createSelector([selectDBAIncementalLogs], (dbaIncementalLogs) => dbaIncementalLogs.list);

export const selectDBAIncementalLogsItemById = (itemId: any) =>
    createSelector(selectDBAIncementalLogsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDBAIncementalLogsQueryItems = createSelector([selectDBAIncementalLogs], (dbaIncementalLogs) => dbaIncementalLogs.query);

export const selectDBAIncementalLogsCreatedItem = createSelector([selectDBAIncementalLogs], (dbaIncementalLogs) => dbaIncementalLogs.create);

export const selectDBAIncementalLogsUpdatedItem = createSelector([selectDBAIncementalLogs], (dbaIncementalLogs) => dbaIncementalLogs.update);

export const selectDBAIncementalLogsReadItem = createSelector([selectDBAIncementalLogs], (dbaIncementalLogs) => dbaIncementalLogs.read);

export const selectDBAIncementalLogsDeletedItem = createSelector([selectDBAIncementalLogs], (dbaIncementalLogs) => dbaIncementalLogs.delete);

export const selectDBAIncementalLogsSearchedItems = createSelector([selectDBAIncementalLogs], (dbaIncementalLogs) => dbaIncementalLogs.search);

export const selectDBAIncementalLogsItemsCount = createSelector([selectDBAIncementalLogs], (dbaIncementalLogs) => dbaIncementalLogs.count);

export const selectDBAIncementalLogsItemsFilter = createSelector([selectDBAIncementalLogs], (dbaIncementalLogs) => dbaIncementalLogs.filter);